module.exports = __webpack_public_path__ + "static/img/game-logo-bg.5f8ee62.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-bg.png
// module id = yU5w
// module chunks = 0 1 2 3 4 5 6